import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Problems() {
  return (
    <section className="intro_section p-100">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={5} xl={5} xxl={5} className="my-auto ">
            <h2 style={{ color: "#000" }}>
              The <span style={{ color: "#76CE51" }}>Problem</span>
            </h2>
            <p>
              For a user-orientated app like Into Go, user journey, navigation
              and user engagement are major aspects where we cannot compromise.
              A self-help app, Into Go, needs to be user-friendly to ensure
              top-notch user experience.
            </p>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto text-center offset-lg-1 "
          >
            <StaticImage
              src="../../../images/case-studies/intogo/problem_img.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={1178}
              height={830}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Problems;
